import { useTranslation } from 'react-i18next';
import {
  SubformComponent,
  SubCardFieldsComponent,
  SubModule,
} from '@/modules/admin/audits/components/submodules/types';
import { LineText } from '@common/components/fragments/LineText';
import AuditsExportsTupCollabsExport from '@/app/spraypaint/audits/exports/AuditsExportsTupCollabsExport';
import { ControlledSelect } from '@common/components/inputs/controlledInput/ControlledSelect';
import useLegalEntitiesSelectOptions from '@/modules/common/legalEntity/useLegalEntitiesSelectOptions';
import useLegalEntities from '@common/legalEntity/useLegalEntities';

export const jsonApiType = AuditsExportsTupCollabsExport.jsonapiType;

export type Values = {
  legalEntityId: AuditsExportsTupCollabsExport['legalEntityId'];
};

export const defaultValues: Values = {
  legalEntityId: '1',
};

function createExportStrategy(data: Values): AuditsExportsTupCollabsExport {
  return new AuditsExportsTupCollabsExport({
    legalEntityId: data.legalEntityId,
  });
}

export const FormComponent: SubformComponent = ({ control }) => {
  const { t } = useTranslation();
  const legalEntityOptions = useLegalEntitiesSelectOptions();

  return (
    <ControlledSelect
      label={t('views.legal_entity.label')}
      className="mt-20"
      control={control}
      defaultValue={undefined}
      name="exportStrategy.params.legalEntityId"
      options={legalEntityOptions}
      required
    />
  );
};

export const CardFieldsComponent: SubCardFieldsComponent<
  AuditsExportsTupCollabsExport
> = ({ strategy: { legalEntityId } }) => {
  const { t } = useTranslation();

  const { legalEntities } = useLegalEntities();
  const legalEntity = (legalEntities || []).find(
    ({ id }) => String(id) === String(legalEntityId),
  );

  return (
    <>
      <LineText
        label={t('activerecord.attributes.audits/export.export_strategy', {
          ns: 'rails',
        })}
        value={t('activerecord.models.audits/exports/tup_collabs_exports', {
          ns: 'rails',
        })}
      />
      <LineText
        label={t(
          'activerecord.attributes.audits/exports/tup_collabs_export.legal_entity_id',
          {
            ns: 'rails',
          },
        )}
        value={legalEntity?.name}
      />
    </>
  );
};

export const AuditsExportsTupCollabsExportSubmodule: SubModule<
  Values,
  AuditsExportsTupCollabsExport
> = {
  jsonApiType,
  defaultValues,
  FormComponent,
  CardFieldsComponent,
  createExportStrategy,
};
